import uuid from "uuid/v4";

import { getConfig } from "../../../../config/app";
import { ProviderData } from "../../../lib/appContext/types";
import { ICta } from "./types";

const basePath = getConfig("basePath");
const path = basePath === "/" ? "" : basePath;

export const buildCarInsuranceFormURL = (businessUnitSlug: string) => {
  const formId = uuid();
  return `${path}/${businessUnitSlug}/form/${formId}/quote`;
};

export const buildTravelInsuranceFormURL = (
  businessUnitConfig: ProviderData["businessUnitConfig"]
) => businessUnitConfig.quoteFormUrl;

export const buildFormURL = (
  businessUnitSlug: string,
  businessUnitConfig: ProviderData["businessUnitConfig"]
) => {
  switch (businessUnitConfig.businessUnit) {
    case "car-insurance":
      return buildCarInsuranceFormURL(businessUnitSlug);
    case "travel-insurance":
      return buildTravelInsuranceFormURL(businessUnitConfig);
    default:
      return "";
  }
};

type GetFormCTA = (data: Pick<ProviderData, "businessUnitConfig" | "businessUnitSlug">) => ICta;

export const getFormCta: GetFormCTA = ({ businessUnitSlug, businessUnitConfig }) => ({
  text: businessUnitConfig.resultCTA,
  url: buildFormURL(businessUnitSlug, businessUnitConfig)
});
